import { S as Splide } from "./chunk.splide_v20251016.js";
import "./chunk.headless_v20251016.js";
import "./chunk.react_v20251016.js";
const debounceEvent = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(void 0, args), wait);
  };
};
/*!
 * @splidejs/splide-extension-auto-scroll
 * Version  : 0.5.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
function empty(array) {
  array.length = 0;
}
function slice$1(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}
function apply$1(func) {
  return func.bind.apply(func, [null].concat(slice$1(arguments, 1)));
}
function raf(func) {
  return requestAnimationFrame(func);
}
function typeOf$1(type, subject) {
  return typeof subject === type;
}
var isArray$1 = Array.isArray;
apply$1(typeOf$1, "function");
apply$1(typeOf$1, "string");
apply$1(typeOf$1, "undefined");
function toArray$1(value) {
  return isArray$1(value) ? value : [value];
}
function forEach$1(values, iteratee) {
  toArray$1(values).forEach(iteratee);
}
var ownKeys$1 = Object.keys;
function forOwn$1(object, iteratee, right) {
  if (object) {
    var keys = ownKeys$1(object);
    keys = keys;
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (key !== "__proto__") {
        if (iteratee(object[key], key) === false) {
          break;
        }
      }
    }
  }
  return object;
}
function assign$1(object) {
  slice$1(arguments, 1).forEach(function(source) {
    forOwn$1(source, function(value, key) {
      object[key] = source[key];
    });
  });
  return object;
}
var min$1 = Math.min;
function EventBinder() {
  var listeners = [];
  function bind(targets, events, callback, options) {
    forEachEvent(targets, events, function(target, event, namespace) {
      var isEventTarget = "addEventListener" in target;
      var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
      isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
      listeners.push([target, event, namespace, callback, remover]);
    });
  }
  function unbind(targets, events, callback) {
    forEachEvent(targets, events, function(target, event, namespace) {
      listeners = listeners.filter(function(listener) {
        if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
          listener[4]();
          return false;
        }
        return true;
      });
    });
  }
  function dispatch(target, type, detail) {
    var e;
    var bubbles = true;
    if (typeof CustomEvent === "function") {
      e = new CustomEvent(type, {
        bubbles,
        detail
      });
    } else {
      e = document.createEvent("CustomEvent");
      e.initCustomEvent(type, bubbles, false, detail);
    }
    target.dispatchEvent(e);
    return e;
  }
  function forEachEvent(targets, events, iteratee) {
    forEach$1(targets, function(target) {
      target && forEach$1(events, function(events2) {
        events2.split(" ").forEach(function(eventNS) {
          var fragment = eventNS.split(".");
          iteratee(target, fragment[0], fragment[1]);
        });
      });
    });
  }
  function destroy() {
    listeners.forEach(function(data) {
      data[4]();
    });
    empty(listeners);
  }
  return {
    bind,
    unbind,
    dispatch,
    destroy
  };
}
var EVENT_MOVE = "move";
var EVENT_MOVED = "moved";
var EVENT_UPDATED = "updated";
var EVENT_DRAG = "drag";
var EVENT_DRAGGED = "dragged";
var EVENT_SCROLL = "scroll";
var EVENT_SCROLLED = "scrolled";
var EVENT_DESTROY = "destroy";
function EventInterface(Splide2) {
  var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
  var binder = EventBinder();
  function on(events, callback) {
    binder.bind(bus, toArray$1(events).join(" "), function(e) {
      callback.apply(callback, isArray$1(e.detail) ? e.detail : []);
    });
  }
  function emit(event) {
    binder.dispatch(bus, event, slice$1(arguments, 1));
  }
  if (Splide2) {
    Splide2.event.on(EVENT_DESTROY, binder.destroy);
  }
  return assign$1(binder, {
    bus,
    on,
    off: apply$1(binder.unbind, bus),
    emit
  });
}
function RequestInterval(interval, onInterval, onUpdate, limit) {
  var now = Date.now;
  var startTime;
  var rate = 0;
  var id;
  var paused = true;
  var count = 0;
  function update() {
    if (!paused) {
      rate = interval ? min$1((now() - startTime) / interval, 1) : 1;
      onUpdate && onUpdate(rate);
      if (rate >= 1) {
        onInterval();
        startTime = now();
        if (limit && ++count >= limit) {
          return pause();
        }
      }
      raf(update);
    }
  }
  function start(resume) {
    !resume && cancel();
    startTime = now() - (resume ? rate * interval : 0);
    paused = false;
    raf(update);
  }
  function pause() {
    paused = true;
  }
  function rewind() {
    startTime = now();
    rate = 0;
    if (onUpdate) {
      onUpdate(rate);
    }
  }
  function cancel() {
    id && cancelAnimationFrame(id);
    rate = 0;
    id = 0;
    paused = true;
  }
  function set(time) {
    interval = time;
  }
  function isPaused() {
    return paused;
  }
  return {
    start,
    rewind,
    pause,
    cancel,
    set,
    isPaused
  };
}
function Throttle(func, duration) {
  var interval;
  function throttled() {
    if (!interval) {
      interval = RequestInterval(duration, function() {
        func();
        interval = null;
      }, null, 1);
      interval.start();
    }
  }
  return throttled;
}
var CLASS_ACTIVE = "is-active";
var SLIDE = "slide";
var FADE = "fade";
function slice(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}
function apply(func) {
  return func.bind(null, ...slice(arguments, 1));
}
function typeOf(type, subject) {
  return typeof subject === type;
}
function isObject(subject) {
  return !isNull(subject) && typeOf("object", subject);
}
const isArray = Array.isArray;
apply(typeOf, "function");
apply(typeOf, "string");
const isUndefined = apply(typeOf, "undefined");
function isNull(subject) {
  return subject === null;
}
function toArray(value) {
  return isArray(value) ? value : [value];
}
function forEach(values, iteratee) {
  toArray(values).forEach(iteratee);
}
function toggleClass(elm, classes, add) {
  if (elm) {
    forEach(classes, (name) => {
      if (name) {
        elm.classList[add ? "add" : "remove"](name);
      }
    });
  }
}
const ownKeys = Object.keys;
function forOwn(object, iteratee, right) {
  if (object) {
    let keys = ownKeys(object);
    keys = keys;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (key !== "__proto__") {
        if (iteratee(object[key], key) === false) {
          break;
        }
      }
    }
  }
  return object;
}
function assign(object) {
  slice(arguments, 1).forEach((source) => {
    forOwn(source, (value, key) => {
      object[key] = source[key];
    });
  });
  return object;
}
function removeAttribute(elms, attrs) {
  forEach(elms, (elm) => {
    forEach(attrs, (attr) => {
      elm && elm.removeAttribute(attr);
    });
  });
}
function setAttribute(elms, attrs, value) {
  if (isObject(attrs)) {
    forOwn(attrs, (value2, name) => {
      setAttribute(elms, name, value2);
    });
  } else {
    forEach(elms, (elm) => {
      isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
  }
}
const { min, max } = Math;
function clamp(number, x, y) {
  const minimum = min(x, y);
  const maximum = max(x, y);
  return min(max(minimum, number), maximum);
}
const DEFAULTS = {
  speed: 1,
  autoStart: true,
  pauseOnHover: true,
  pauseOnFocus: true
};
const I18N = {
  startScroll: "Start auto scroll",
  pauseScroll: "Pause auto scroll"
};
function AutoScroll(Splide2, Components2, options) {
  const { on, off, bind, unbind } = EventInterface(Splide2);
  const { translate, getPosition, toIndex, getLimit } = Components2.Move;
  const { setIndex, getIndex } = Components2.Controller;
  const { orient } = Components2.Direction;
  const { toggle } = Components2.Elements;
  const { Live } = Components2;
  const { root } = Splide2;
  const throttledUpdateArrows = Throttle(Components2.Arrows.update, 500);
  let autoScrollOptions = {};
  let interval;
  let stopped;
  let hovered;
  let focused;
  let busy;
  let currPosition;
  function setup() {
    const { autoScroll } = options;
    autoScrollOptions = assign({}, DEFAULTS, isObject(autoScroll) ? autoScroll : {});
  }
  function mount() {
    if (!Splide2.is(FADE)) {
      if (!interval && options.autoScroll !== false) {
        interval = RequestInterval(0, move);
        listen();
        autoStart();
      }
    }
  }
  function destroy() {
    if (interval) {
      interval.cancel();
      interval = null;
      currPosition = void 0;
      off([EVENT_MOVE, EVENT_DRAG, EVENT_SCROLL, EVENT_MOVED, EVENT_SCROLLED]);
      unbind(root, "mouseenter mouseleave focusin focusout");
      unbind(toggle, "click");
    }
  }
  function listen() {
    if (autoScrollOptions.pauseOnHover) {
      bind(root, "mouseenter mouseleave", (e) => {
        hovered = e.type === "mouseenter";
        autoToggle();
      });
    }
    if (autoScrollOptions.pauseOnFocus) {
      bind(root, "focusin focusout", (e) => {
        focused = e.type === "focusin";
        autoToggle();
      });
    }
    if (autoScrollOptions.useToggleButton) {
      bind(toggle, "click", () => {
        stopped ? play() : pause();
      });
    }
    on(EVENT_UPDATED, update);
    on([EVENT_MOVE, EVENT_DRAG, EVENT_SCROLL], () => {
      busy = true;
      pause(false);
    });
    on([EVENT_MOVED, EVENT_DRAGGED, EVENT_SCROLLED], () => {
      busy = false;
      autoToggle();
    });
  }
  function update() {
    const { autoScroll } = options;
    if (autoScroll !== false) {
      autoScrollOptions = assign({}, autoScrollOptions, isObject(autoScroll) ? autoScroll : {});
      mount();
    } else {
      destroy();
    }
    if (interval && !isUndefined(currPosition)) {
      translate(currPosition);
    }
  }
  function autoStart() {
    if (autoScrollOptions.autoStart) {
      if (document.readyState === "complete") {
        play();
      } else {
        bind(window, "load", play);
      }
    }
  }
  function play() {
    if (isPaused()) {
      interval.start(true);
      Live.disable(true);
      focused = hovered = stopped = false;
      updateButton();
    }
  }
  function pause(stop = true) {
    if (!stopped) {
      stopped = stop;
      updateButton();
      if (!isPaused()) {
        interval.pause();
        Live.disable(false);
      }
    }
  }
  function autoToggle() {
    if (!stopped) {
      hovered || focused || busy ? pause(false) : play();
    }
  }
  function move() {
    const position = getPosition();
    const destination = computeDestination(position);
    if (position !== destination) {
      translate(destination);
      updateIndex(currPosition = getPosition());
    } else {
      pause(false);
      if (autoScrollOptions.rewind) {
        Splide2.go(autoScrollOptions.speed > 0 ? 0 : Components2.Controller.getEnd());
      }
    }
    throttledUpdateArrows();
  }
  function computeDestination(position) {
    const speed = autoScrollOptions.speed || 1;
    position += orient(speed);
    if (Splide2.is(SLIDE)) {
      position = clamp(position, getLimit(false), getLimit(true));
    }
    return position;
  }
  function updateIndex(position) {
    const { length } = Splide2;
    const index = (toIndex(position) + length) % length;
    if (index !== getIndex()) {
      setIndex(index);
      Components2.Slides.update();
      Components2.Pagination.update();
      options.lazyLoad === "nearby" && Components2.LazyLoad.check();
    }
  }
  function updateButton() {
    if (toggle) {
      const key = stopped ? "startScroll" : "pauseScroll";
      toggleClass(toggle, CLASS_ACTIVE, !stopped);
      setAttribute(toggle, "aria-label", options.i18n[key] || I18N[key]);
    }
  }
  function isPaused() {
    return !interval || interval.isPaused();
  }
  return {
    setup,
    mount,
    destroy,
    play,
    pause,
    isPaused
  };
}
if (!customElements.get("secondary-hero-image-slider")) {
  customElements.define(
    "secondary-hero-image-slider",
    class SecondaryHeroImageSlider extends HTMLElement {
      constructor() {
        super();
        const aTarget = this.querySelector(".splide");
        new Splide(aTarget, {
          gap: "1rem",
          mediaQuery: "min",
          fixedWidth: "92%",
          padding: { left: "24px", right: "24px" },
          autoHeight: true,
          arrows: false,
          classes: {
            pagination: "splide__pagination storytelling-card-slider"
          },
          breakpoints: {
            768: {
              padding: { left: "0", right: "0" },
              fixedWidth: "50%",
              arrows: true,
              pagination: false
            },
            1024: {
              destroy: true
            }
          }
        }).mount();
      }
    }
  );
}
if (!customElements.get("secondary-hero-pxg-image-slider")) {
  customElements.define(
    "secondary-hero-pxg-image-slider",
    class SecondaryHeroPxgImageSlider extends HTMLElement {
      constructor() {
        var _a;
        super();
        const count = (_a = this.dataset) == null ? void 0 : _a.count;
        const aTarget = this.querySelector(".splide");
        const splide = new Splide(aTarget, {
          gap: "1rem",
          padding: { left: "0", right: "0" },
          perPage: parseInt(count),
          arrows: true,
          pagination: true,
          classes: {
            pagination: "splide__pagination pxg-splide-pagination !-bottom-9",
            arrow: "splide__arrow pxg-splide-arrow",
            prev: "splide__arrow--prev !-left-12",
            next: "splide__arrow--next !-right-9"
          },
          breakpoints: {
            768: {
              fixedWidth: "95%",
              perPage: 1,
              padding: { left: "24px", right: "24px" }
            },
            1259: {
              arrows: false,
              width: "100%"
            }
          }
        });
        const handleAria = () => {
          const splideArrows = this.querySelectorAll(".splide__arrow svg");
          if (splideArrows) {
            for (const arrow of splideArrows) {
              arrow.setAttribute("aria-hidden", "true");
            }
          }
        };
        splide.on("ready", handleAria);
        splide.on("overflow", (isOverflow) => {
          splide.options = {
            pagination: isOverflow,
            drag: isOverflow
          };
        });
        splide.mount();
      }
    }
  );
}
if (!customElements.get("pxg-store-page-image-gallery")) {
  customElements.define(
    "pxg-store-page-image-gallery",
    class PxgStorePageImageGallery extends HTMLElement {
      constructor() {
        super();
        const aTarget = this.querySelector(".splide");
        const splide = new Splide(aTarget, {
          gap: "1rem",
          fixedWidth: "24%",
          pagination: false,
          breakpoints: {
            768: {
              fixedWidth: "100%"
            },
            1024: {
              fixedWidth: "50%"
            }
          }
        });
        splide.on("overflow", (isOverflow) => {
          splide.options = {
            arrows: isOverflow,
            drag: isOverflow
          };
        });
        splide.mount();
      }
    }
  );
}
if (!customElements.get("related-article-slider")) {
  customElements.define(
    "related-article-slider",
    class RelatedArticleSlider extends HTMLElement {
      constructor() {
        super();
        const aTarget = this.querySelector(".splide");
        const splide = new Splide(aTarget, {
          gap: "1rem",
          perPage: 3,
          arrows: false,
          classes: {
            pagination: "splide__pagination pxg-splide-pagination !-bottom-7"
          },
          breakpoints: {
            1024: {
              padding: { left: "24px", right: "24px" },
              fixedWidth: "92%"
            }
          }
        });
        splide.on("overflow", (isOverflow) => {
          splide.options = {
            pagination: isOverflow,
            drag: isOverflow
          };
        });
        splide.mount();
      }
    }
  );
}
if (!customElements.get("mobile-product-media-slider")) {
  customElements.define(
    "mobile-product-media-slider",
    class MobileProductMediaSlider extends HTMLElement {
      constructor() {
        super();
        const mainSlider = this.querySelector(".mobile-product-media-slider");
        const main = new Splide(mainSlider, {
          type: "loop",
          perPage: 1,
          gap: "1rem",
          pagination: false,
          arrows: true
        });
        main.mount();
      }
    }
  );
}
if (!customElements.get("slider-component-multicol")) {
  customElements.define(
    "slider-component-multicol",
    class SliderComponentMulticol extends HTMLElement {
      constructor() {
        super();
        const aTarget = this.querySelector(".splide");
        let mobileSettings = {};
        if (this.dataset.mobileEnabled === "true") {
          mobileSettings = {
            perPage: this.dataset.mobileCols,
            arrows: false
          };
        } else {
          mobileSettings.destroy = true;
        }
        let paginationPaddingClass = "!pb-4";
        if (this.dataset.hasCtaBtn === "true") {
          paginationPaddingClass += " lg:!pb-0";
        }
        const splide = new Splide(aTarget, {
          gap: "5rem",
          mediaQuery: "max",
          arrows: true,
          perPage: this.dataset.desktopCols,
          perMove: 1,
          focus: 0,
          omitEnd: true,
          pagination: true,
          rewind: true,
          classes: {
            pagination: "splide__pagination pxg-splide-pagination storytelling-card-slider !-bottom-7 " + paginationPaddingClass,
            arrow: "splide__arrow pxg-splide-arrow",
            prev: "splide__arrow--prev !-left-16 mt-[-40px]",
            next: "splide__arrow--next !-right-16 mt-[-40px]"
          },
          breakpoints: {
            1023: mobileSettings
          }
        });
        const handleAria = () => {
          const splideArrows = this.querySelectorAll(".splide__arrow svg");
          if (splideArrows) {
            for (const arrow of splideArrows) {
              arrow.setAttribute("aria-hidden", "true");
            }
          }
        };
        splide.on("ready", handleAria);
        splide.on("overflow", (isOverflow) => {
          splide.options = {
            pagination: isOverflow,
            drag: isOverflow
          };
        });
        splide.mount();
      }
    }
  );
}
const genericPXGSlider = document.querySelector(".slider-component-pxg-generic");
if (genericPXGSlider) {
  const genericPXGSliderSplideWrapper = genericPXGSlider.querySelector(".splide");
  let genericPXGSliderMobileSettings = {};
  if (genericPXGSlider.dataset.mobileEnabled === "true") {
    genericPXGSliderMobileSettings = {
      arrows: true
    };
  } else {
    genericPXGSliderMobileSettings.destroy = true;
  }
  const genericPXGSliderNav = document.querySelector(".slider-component-pxg-generic-nav");
  const genericPXGSliderSplide = new Splide(genericPXGSliderSplideWrapper, {
    type: genericPXGSlider.dataset.sliderType,
    gap: "5rem",
    mediaQuery: "max",
    arrows: true,
    perMove: 1,
    focus: 0,
    pagination: true,
    rewind: true,
    classes: {
      pagination: "splide__pagination pxg-splide-pagination storytelling-card-slider !-bottom-10",
      arrow: "splide__arrow pxg-splide-arrow",
      prev: "splide__arrow--prev !-left-16 mt-[-40px]",
      next: "splide__arrow--next !-right-16 mt-[-40px]"
    },
    breakpoints: {
      1023: genericPXGSliderMobileSettings
    }
  });
  const splideHandleAria = (elem) => {
    const splideArrows = elem.querySelectorAll(".splide__arrow svg");
    if (splideArrows) {
      for (const arrow of splideArrows) {
        arrow.setAttribute("aria-hidden", "true");
      }
    }
  };
  genericPXGSliderSplide.on("ready", () => {
    splideHandleAria(genericPXGSlider);
  });
  genericPXGSliderSplide.on("overflow", (isOverflow) => {
    genericPXGSliderSplide.options = {
      pagination: isOverflow,
      drag: isOverflow
    };
    if (genericPXGSlider.dataset.sliderType != "fade") {
      genericPXGSliderSplide.options.omitEnd = true;
    }
    if (genericPXGSlider.dataset.hasNavigationSplide) {
      genericPXGSliderSplide.options.pagination = false;
    }
  });
  if (genericPXGSliderNav) {
    const genericPXGSliderNavSplideWrapper = genericPXGSliderNav.querySelector(".splide");
    const genericPXGSliderNavSplide = new Splide(genericPXGSliderNavSplideWrapper, {
      gap: "5rem",
      mediaQuery: "max",
      arrows: false,
      perPage: 3,
      omitEnd: true,
      pagination: false,
      isNavigation: true,
      rewind: true,
      breakpoints: {
        1023: {
          destroy: true
        }
      }
    });
    genericPXGSliderNavSplide.on("ready", () => {
      splideHandleAria(genericPXGSliderNav);
    });
    genericPXGSliderNavSplide.on("overflow", (isOverflow) => {
      genericPXGSliderNavSplide.options = {
        pagination: isOverflow,
        drag: isOverflow
      };
    });
    const genericPXGSliderNavSplideItems = genericPXGSliderNav.querySelectorAll(".pxg-generic-slider-list-nav__item");
    let current;
    if (genericPXGSliderNavSplideItems) {
      let initThumbnail = function(thumbnail, index) {
        thumbnail.addEventListener("click", function() {
          genericPXGSliderSplide.go(index);
        });
      };
      for (var i = 0; i < genericPXGSliderNavSplideItems.length; i++) {
        initThumbnail(genericPXGSliderNavSplideItems[i], i);
      }
      genericPXGSliderSplide.on("mounted move", function() {
        let thumbnail = genericPXGSliderNavSplideItems[genericPXGSliderSplide.index];
        if (thumbnail) {
          if (current) {
            current.classList.remove("is-active");
          }
          thumbnail.classList.add("is-active");
          current = thumbnail;
        }
      });
    }
    genericPXGSliderSplide.sync(genericPXGSliderNavSplide);
    genericPXGSliderSplide.mount();
    genericPXGSliderNavSplide.mount();
  } else {
    genericPXGSliderSplide.mount();
  }
}
if (!customElements.get("storytelling-card-slider")) {
  customElements.define(
    "storytelling-card-slider",
    class StorytellingCardSlider extends HTMLElement {
      constructor() {
        var _a, _b;
        super();
        const isLargeCard = (_a = this.dataset) == null ? void 0 : _a.cardSizeLarge;
        const autoscroll = (_b = this.dataset) == null ? void 0 : _b.autoscroll;
        const aTarget = this.querySelector(".splide");
        const breakpoints = !!isLargeCard ? {
          768: {
            fixedWidth: "32%",
            perPage: 3
          },
          1440: {
            fixedWidth: "",
            width: "1872px",
            padding: { left: "0", right: "0" },
            perPage: 4
          }
        } : {
          768: {
            fixedWidth: "45%",
            perPage: 3
          },
          992: {
            fixedWidth: "38%"
          },
          1440: {
            fixedWidth: "",
            width: "1872px",
            padding: { left: "0", right: "0" },
            perPage: 4
          }
        };
        const splide = new Splide(aTarget, {
          gap: "1rem",
          mediaQuery: "min",
          fixedWidth: "92%",
          padding: { left: "24px", right: "24px" },
          arrows: false,
          type: autoscroll ? "loop" : "slide",
          drag: autoscroll ? "free" : true,
          perMove: 1,
          classes: {
            pagination: "splide__pagination pxg-splide-pagination !-bottom-7"
          },
          breakpoints
        });
        splide.on("overflow", (isOverflow) => {
          splide.options = {
            pagination: isOverflow,
            drag: isOverflow
          };
        });
        if (autoscroll) {
          splide.mount({ AutoScroll });
        } else {
          splide.mount();
        }
      }
    }
  );
}
if (!customElements.get("image-gallery-pxg")) {
  customElements.define(
    "image-gallery-pxg",
    class ImageGalleryPxg extends HTMLElement {
      constructor() {
        super();
        const aTarget = this.querySelector(".splide");
        const splide = new Splide(aTarget, {
          gap: "24px",
          perPage: 4,
          pagination: true,
          arrows: false,
          type: "loop",
          classes: {
            pagination: "splide__pagination pxg-splide-pagination !-bottom-10"
          },
          breakpoints: {
            768: {
              perPage: 1,
              padding: { left: "0px", right: "0px" }
            },
            1024: {
              perPage: 2
            }
          }
        });
        splide.on("overflow", (isOverflow) => {
          splide.options = {
            pagination: isOverflow,
            drag: isOverflow
          };
        });
        splide.mount();
      }
    }
  );
}
if (!customElements.get("club-comparison-slider")) {
  customElements.define(
    "club-comparison-slider",
    class ClubComparisonSlider extends HTMLElement {
      constructor() {
        var _a;
        super();
        const aTarget = this.querySelector(".splide");
        const count = (_a = this.dataset) == null ? void 0 : _a.count;
        this.clubComparisonSpecs = this.querySelectorAll("[data-club-comparison-specs]");
        this.clubComparisonModelCharacteristics = this.querySelectorAll("[data-club-comparison-model-characteristics]");
        this.clubComparisonDescription = this.querySelectorAll("[data-club-comparison-description]");
        let breakpoints = {
          768: {
            fixedWidth: "95%",
            perPage: 1,
            padding: { left: "24px", right: "24px" }
          }
        };
        const additional = {
          1024: {
            fixedWidth: "47%"
          }
        };
        if (count >= 3) {
          breakpoints = { ...breakpoints, ...additional };
        }
        const splide = new Splide(aTarget, {
          gap: "24px",
          perPage: parseInt(count) === 2 ? 2 : 3,
          perMove: 1,
          width: parseInt(count) === 2 ? "920px" : "1344px",
          padding: { left: "24px", right: "24px" },
          pagination: true,
          arrows: false,
          classes: {
            pagination: "splide__pagination pxg-splide-pagination !-bottom-9"
          },
          breakpoints
        });
        window.addEventListener(
          "resize",
          debounceEvent((event) => {
            this.init(event);
          }, 300).bind(this)
        );
        splide.on("overflow", (isOverflow) => {
          splide.options = {
            pagination: isOverflow,
            drag: isOverflow
          };
        });
        splide.on("ready", () => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              this.init();
            }, 50);
          });
        });
        splide.on("moved", () => {
          setTimeout(() => {
            this.init();
          }, 100);
        });
        splide.mount();
      }
      init() {
        this.matchHeights(this.clubComparisonSpecs);
        this.matchHeights(this.clubComparisonModelCharacteristics);
        this.matchHeights(this.clubComparisonDescription);
        this.verifyAndRetryHeights();
      }
      verifyAndRetryHeights() {
        const allElements = [
          ...this.clubComparisonSpecs,
          ...this.clubComparisonModelCharacteristics,
          ...this.clubComparisonDescription
        ];
        const needsRetry = allElements.some((el) => {
          const computedStyle = window.getComputedStyle(el);
          return computedStyle.height === "auto" || computedStyle.height === "0px";
        });
        if (needsRetry) {
          setTimeout(() => {
            this.matchHeights(this.clubComparisonSpecs);
            this.matchHeights(this.clubComparisonModelCharacteristics);
            this.matchHeights(this.clubComparisonDescription);
          }, 200);
        }
      }
      matchHeights(elements) {
        if (!elements || elements.length === 0) return;
        let maxHeight = 0;
        elements.forEach((el) => {
          if (el && el.offsetHeight) {
            const height = el.offsetHeight;
            if (height > maxHeight) {
              maxHeight = height;
            }
          }
        });
        if (maxHeight > 0) {
          elements.forEach((el) => {
            if (el) {
              el.style.height = `${maxHeight}px`;
            }
          });
        }
      }
    }
  );
}
if (!customElements.get("product-list-slider")) {
  customElements.define(
    "product-list-slider",
    class ProductListSlider extends HTMLElement {
      constructor() {
        super();
        const aTarget = this.querySelector(".splide");
        const splideList = this.querySelector(".splide__list");
        const slideItems = this.querySelectorAll(".splide__slide");
        const itemCount = slideItems.length;
        const splide = new Splide(aTarget, {
          gap: "1rem",
          mediaQuery: "min",
          fixedWidth: "92%",
          padding: { left: "24px", right: "24px" },
          arrows: false,
          pagination: true,
          classes: {
            pagination: "splide__pagination pxg-splide-pagination !-bottom-10"
          },
          breakpoints: {
            768: {
              fixedWidth: "",
              perPage: 2,
              arrows: false
            },
            1024: {
              fixedWidth: "",
              perPage: itemCount,
              arrows: false
            }
          }
        });
        splide.on("overflow", (isOverflow) => {
          splideList.classList.toggle("justify-center", !isOverflow);
          splide.options = {
            pagination: isOverflow,
            drag: isOverflow
          };
        });
        splide.mount();
      }
    }
  );
}
if (!customElements.get("pxg-store-slider-section")) {
  customElements.define(
    "pxg-store-slider-section",
    class PxgStoreSliderSection extends HTMLElement {
      constructor() {
        super();
        const aTarget = this.querySelector(".splide");
        const splide = new Splide(aTarget, {
          gap: "1rem",
          mediaQuery: "min",
          fixedWidth: "92%",
          padding: { left: "24px", right: "24px" },
          arrows: true,
          pagination: false,
          classes: {
            arrow: "splide__arrow !top-1/3",
            pagination: "splide__pagination pxg-splide-pagination !-bottom-10"
          },
          breakpoints: {
            768: {
              padding: { left: "0", right: "0" },
              fixedWidth: "",
              perPage: 3,
              arrows: false,
              pagination: true
            },
            1024: {
              fixedWidth: "",
              padding: { left: "0", right: "0" },
              perPage: 4,
              arrows: false
            },
            1280: {
              fixedWidth: "",
              padding: { left: "0", right: "0" },
              perPage: 5,
              arrows: false
            }
          }
        });
        const handleAria = () => {
          const splideArrows = this.querySelectorAll(".splide__arrow svg");
          if (splideArrows) {
            for (const arrow of splideArrows) {
              arrow.setAttribute("aria-hidden", "true");
            }
          }
        };
        splide.on("ready", handleAria);
        splide.on("overflow", (isOverflow) => {
          splide.options = {
            arrows: isOverflow,
            drag: isOverflow,
            breakpoints: {
              768: {
                pagination: isOverflow
              },
              1024: {
                pagination: isOverflow
              },
              1280: {
                pagination: isOverflow
              }
            }
          };
        });
        splide.mount();
      }
    }
  );
}
if (!customElements.get("pxg-vertical-media-slider")) {
  customElements.define(
    "pxg-vertical-media-slider",
    class PxgVerticalMediaSlider extends HTMLElement {
      constructor() {
        super();
        const aTarget = this.querySelector(".splide");
        const splide = new Splide(aTarget, {
          direction: "ttb",
          fixedWidth: "94px",
          fixedHeight: "94px",
          height: "420px",
          heightRatio: 1,
          gap: "16px",
          rewind: true,
          pagination: false,
          isNavigation: true,
          perPage: 4,
          arrows: true
        });
        const handleAria = () => {
          const splideArrows = this.querySelectorAll(".splide__arrow svg");
          if (splideArrows) {
            for (const arrow of splideArrows) {
              arrow.setAttribute("aria-hidden", "true");
            }
          }
        };
        splide.on("ready", handleAria);
        const splideInteraction = (index, event) => {
          var _a, _b;
          const mediaId = (_b = (_a = index == null ? void 0 : index.slide) == null ? void 0 : _a.dataset) == null ? void 0 : _b.thumbId;
          const aMediaItem = document.querySelector(`[data-media-id="${mediaId}"]`);
          if (!aMediaItem) return;
          aMediaItem.scrollIntoView({
            behavior: "smooth"
          });
        };
        const splideOverflow = (isOverflow) => {
          splide.options = {
            arrows: isOverflow,
            drag: isOverflow
          };
        };
        splide.on("ready", () => {
          splide.on("arrows:updated", (prev, next, prevIndex, nextIndex) => {
            var _a;
            const aMediaItemEl = aTarget.querySelector(`[data-index="${nextIndex}"]`);
            const mediaId = (_a = aMediaItemEl == null ? void 0 : aMediaItemEl.dataset) == null ? void 0 : _a.thumbId;
            const aMediaItem = document.querySelector(`[data-media-id="${mediaId}"]`);
            if (!aMediaItem) return;
            aMediaItem.scrollIntoView({
              behavior: "smooth"
            });
          });
        });
        splide.on("click", splideInteraction);
        splide.on("overflow", splideOverflow);
        splide.mount();
      }
    }
  );
}
if (!customElements.get("product-media-slider")) {
  customElements.define(
    "product-media-slider",
    class ProductMediaSlider extends HTMLElement {
      constructor() {
        super();
        this.mainSlider = this.querySelector(".product-media-slider");
        this.thumbnailSlider = this.querySelector(".thumbnail-slider");
        this.thumbnailSlider.style.height = "fit-content";
        this.thumbnailSlider.style.paddingBlock = "70px";
        this.main = new Splide(this.mainSlider, {
          type: "loop",
          perPage: 1,
          gap: "1rem",
          pagination: false
        });
        this.thumbnails = new Splide(this.thumbnailSlider, {
          direction: "ttb",
          fixedWidth: "94px",
          fixedHeight: "94px",
          height: "420px",
          heightRatio: 1,
          gap: "16px",
          rewind: true,
          pagination: false,
          isNavigation: true,
          perPage: 4,
          arrows: true
        });
        const handleAria = () => {
          const splideArrows = this.querySelectorAll(".splide__arrow svg");
          if (splideArrows) {
            for (const arrow of splideArrows) {
              arrow.setAttribute("aria-hidden", "true");
            }
          }
        };
        this.main.on("ready", handleAria);
        this.thumbnails.on("ready", handleAria);
        this.quickAddModal = this.closest("quick-add-modal");
        if (this.quickAddModal) {
          this.quickAddModal.addEventListener("product-info:loaded", this.productInfoLoaded.bind(this));
        }
      }
      connectedCallback() {
        const mainOverflow = (isOverflow) => {
          this.main.options = {
            arrows: isOverflow,
            drag: isOverflow
          };
        };
        const thumbnailsOverflow = (isOverflow) => {
          this.thumbnails.options = {
            arrows: isOverflow,
            drag: isOverflow
          };
        };
        this.main.on("overflow", mainOverflow);
        this.thumbnails.on("overflow", thumbnailsOverflow);
        this.main.sync(this.thumbnails);
        this.main.mount();
        this.thumbnails.mount();
      }
      productInfoLoaded() {
        setTimeout(() => {
          this.main.refresh();
        }, 1);
      }
    }
  );
}
if (!customElements.get("card-accordion-pxg")) {
  customElements.define(
    "card-accordion-pxg",
    class CardAccordionPxg extends HTMLElement {
      constructor() {
        var _a;
        super();
        this.mainDetailsToggle = this.querySelector("details");
        const initialOpen = (_a = this.mainDetailsToggle.dataset) == null ? void 0 : _a.initialOpen;
        const mediaQuery = window.matchMedia("(min-width: 768px)");
        const handleTabletChange = (e) => {
          if (e.matches) {
            this.mainDetailsToggle.setAttribute("open", "");
          } else {
            if (!initialOpen) {
              this.mainDetailsToggle.removeAttribute("open");
            }
          }
        };
        mediaQuery.addEventListener("change", handleTabletChange);
        handleTabletChange(mediaQuery);
      }
    }
  );
}
if (!customElements.get("secondary-nav-pxg")) {
  customElements.define(
    "secondary-nav-pxg",
    class SecondaryNavPxg extends HTMLElement {
      constructor() {
        super();
        this.mainDetailsToggle = this.querySelector("details");
        this.isMobile = false;
        this.onBodyClick = this.handleBodyClick.bind(this);
        const items = this.querySelectorAll("[data-click-close]");
        items.forEach((item) => {
          item.addEventListener("click", (event) => {
            if (this.isMobile) {
              window.requestAnimationFrame(() => this.mainDetailsToggle.removeAttribute("open"));
            }
          });
        });
        const mediaQuery = window.matchMedia("(min-width: 1024px)");
        const handleTabletChange = (e) => {
          if (e.matches) {
            this.isMobile = false;
            this.mainDetailsToggle.setAttribute("open", "");
            window.removeEventListener("click", this.onBodyClick);
          } else {
            this.isMobile = true;
            window.addEventListener("click", this.onBodyClick);
            this.mainDetailsToggle.removeAttribute("open");
          }
        };
        mediaQuery.addEventListener("change", handleTabletChange);
        handleTabletChange(mediaQuery);
      }
      handleBodyClick(e) {
        if (!this.contains(e.target)) {
          if (this.mainDetailsToggle.hasAttribute("open")) {
            this.mainDetailsToggle.removeAttribute("open");
          }
        }
      }
    }
  );
}
if (!customElements.get("affirm-watcher")) {
  customElements.define(
    "affirm-watcher",
    class AffirmWatcher extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", this.affirmRefresh);
        } else {
          this.affirmRefresh();
        }
      }
      affirmRefresh() {
        var _a, _b;
        if ("affirm" in window) {
          (_b = (_a = window == null ? void 0 : window.affirm) == null ? void 0 : _a.ui) == null ? void 0 : _b.refresh();
        }
      }
    }
  );
}
if (!customElements.get("scroll-top-btn")) {
  customElements.define(
    "scroll-top-btn",
    class ScrollTopBtn extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        const aBtn = this.querySelector(".js-scroll-top");
        if (!aBtn) return;
        aBtn.addEventListener("click", () => {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        });
      }
    }
  );
}
